import React, { Component } from 'react';
import {
    withRouter
} from 'react-router-dom';
import {
    Page,
    Card,
    Text,
    BlockStack,
    Banner,
    Checkbox,
    Badge,
    Collapsible,
} from '@shopify/polaris';
import {

} from '@shopify/polaris-icons';
import SkeltonLoading from "../../../components/SkeltonLoading";
import {
    reqGetImgOptTotal,
    reqSaveSettings,
    reqGetAltData,
} from '../../../api';
import { connect } from 'react-redux'
import { setSaveSwitchData } from '../../../redux/actions/getAppPublicData';
import Language from '../../../i18n/Language';
import { store } from '../../../redux/store';
import { cloneDeep, debounce } from 'lodash';
import './index.scss';
import FaqCardBox from '../../../components/FaqCardBox';
import { setPageData } from '../../../redux/actions/getAppPageData';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
import FreeTagInputMix from "../../../components/FreeTagInput";
import FreeTagInputTraceless from "../../../components/FreeTagInput/indexV2";
import Switch from "react-switch";
import SaveBarTop from '../../../components/SaveBarTop';
import HistoryTable from './historyTable';

const t = Language;

class indexClass extends Component {
    state = {
        //页面动作
        loading: true,
        loadingPage: true,
        LanguageRefreshData: false,
        existUser: false, // 是否存在首次设置
        // 表格条数
        current_PageSize: 5,
        current_PageSize_alt: 5,
        isShowQuotaImage: true, // 额度banner状态
        // faq
        questionList: {
            w_alt: {
                title: "What is an ALT text?",
                tag: ["ALT text is an HTML attribute used to provide alternative text descriptions for images. It is used to convey the content of an image to users when the image cannot be displayed or is being read by screen readers."]
            },
            wr_alt: {
                title: "Why is necessary to write ALT tags?",
                tag: ["ALT tags improve accessibility and SEO, describe image content, enhance user experience, and increase search engine visibility."]
            },
        },
        level: 1, // 等级
        switchLoading: false, // 开关loading
        auto_switch: false,
        isShowAutoState: false, // 是否展示自动状态
        FirstSetActive: false, // 首次设置弹窗状态
        isShowManuallyModal: false, // 手动弹窗状态
        firstSetSheetActive: false, // 抽屉状态

        is_default: 1, // 是否第一次设置
        total_saved_size: 0, // 比特单位
        avg_saved_space: 0,
        avg_saved_percent: 0,
        total_original_size: 0,
        total_compress_size: 0,
        optimize_status: 0,

        impressionsUse: 0, // 使用额度
        impressionsAll: 0, // 总额度
        impressionsProportion: 0,  // 占比额度
        freeQuota: 150,  // 免费额度

        image_opt: {}, // 基础设置
        alt_text: {}, // alt设置
        file_name: {}, // 文件名称设置

        isShowImgCompression: false, // 开关状态
        isShowImgAltText: false, // 开关状态
        isShowImgFilename: false, // 开关状态
        productImg: 0, // check状态
        ColImg: false, // check状态
        BlogImg: false, // check状态
        ConvertImg: false, // check状态
        AddWaterImg: false, // check状态
        productAlt: 0, // check状态
        ColAlt: false, // check状态
        BlogAlt: false, // check状态
        blankImgAlt: false, // check状态
        productFile: 0, // check状态
        ColFile: false, // check状态
        BlogFile: false, // check状态
        setSaveLoading: false, // 保存设置loading
        setSaveDisabled: true, // 是否禁用save
        tagSet: {},
        proAltTag: '',    // tag输入框
        colAltTag: '',
        blogAltTag: '',
        proFileTag: '',
        colFileTag: '',
        blogFileTag: '',
        productAltList: [
            {
                content: 'Product title',
                onAction: () => this.addApplyField('Product title', 'ProductAltFixTag')
            },
            {
                content: 'Product vendor',
                onAction: () => this.addApplyField('Product vendor', 'ProductAltFixTag')
            },
            {
                content: 'Product type',
                onAction: () => this.addApplyField('Product type', 'ProductAltFixTag')
            },
            {
                content: 'Price',
                onAction: () => this.addApplyField('Price', 'ProductAltFixTag')
            },
            {
                content: 'Shop name',
                onAction: () => this.addApplyField('Shop name', 'ProductAltFixTag')
            },
            {
                content: 'Product variant',
                onAction: () => this.addApplyField('Product variant', 'ProductAltFixTag')
            },
        ],
        colAltTagList: [
            {
                content: 'Collection title',
                onAction: () => this.addApplyField('Collection title', 'ColAltFixTag')
            },
            {
                content: 'Shop name',
                onAction: () => this.addApplyField('Shop name', 'ColAltFixTag')
            }
        ],
        blogAltTagList: [
            {
                content: 'Blog title',
                onAction: () => this.addApplyField('Blog title', 'BlogAltFixTag')
            },
            {
                content: 'Shop name',
                onAction: () => this.addApplyField('Shop name', 'BlogAltFixTag')
            }
        ],
        productFileList: [
            {
                content: 'Product title',
                onAction: () => this.addApplyField('Product title', 'ProductFileFixTag')
            },
            {
                content: 'Product vendor',
                onAction: () => this.addApplyField('Product vendor', 'ProductFileFixTag')
            },
            {
                content: 'Product type',
                onAction: () => this.addApplyField('Product type', 'ProductFileFixTag')
            },
            {
                content: 'Price',
                onAction: () => this.addApplyField('Price', 'ProductFileFixTag')
            },
            {
                content: 'Shop name',
                onAction: () => this.addApplyField('Shop name', 'ProductFileFixTag')
            },
            {
                content: 'Product variant',
                onAction: () => this.addApplyField('Product variant', 'ProductFileFixTag')
            },
        ],
        colFileTagList: [
            {
                content: 'Collection title',
                onAction: () => this.addApplyField('Collection title', 'ColFileFixTag')
            },
            {
                content: 'Shop name',
                onAction: () => this.addApplyField('Shop name', 'ColFileFixTag')
            }
        ],
        blogFileTagList: [
            {
                content: 'Blog title',
                onAction: () => this.addApplyField('Blog title', 'BlogFileFixTag')
            },
            {
                content: 'Shop name',
                onAction: () => this.addApplyField('Shop name', 'BlogFileFixTag')
            }
        ],

        isShowSheetLoading: true,  // sheet loading
        allTagList: {}, // 初始化tag
        manuallyTabKey: 0, // 手动列表索引
        manuallyTableData: [], // 手动优化图片列表
        manuallyTableRes: {}, // 手动列表总数据
        manuallyQueryVal: '', // 手动搜索value
        mPage: 1, // 手动页码
        mPageSize: 10, // 条数

        showImageUploadBanner: false,
        setUpdateImageWarning: null,
        uploadedFiles: null,
        fileUpload: null,
        imgButton: true,    //图片删除按钮
        imageAddWatermarkPosition: '',
        imageAddWatermarkSize: 0,
        imageAddWatermarkOpacity: 1,

        ProductAltFixTag: {}, // tag输入对象
        ColAltFixTag: {}, // --
        BlogAltFixTag: {}, // --
        ProductFileFixTag: {}, // --
        ColFileFixTag: {}, // --
        BlogFileFixTag: {}, // tag输入对象
        imageAddWatermarkImg: '/ImageOpt/watermark.png', // 图片对象数据

        hPage: 1,   // 历史记录 页码
        hPageSize: 10,   // 历史记录 条数
        historyTableRes: {}, // 接口数据
        historyQueryVal: '',   // 历史记录 搜索
        historyTabKey: 0,   // 历史记录 索引
        historyTableData: [], // 表格数据
        historyTabLoading: true, // loading历史记录表

        isImageCompression: false,  // 当前开关状态
        isConvertImage: false,  // 当前开关状态
        isAddWatermark: false,  // 当前开关状态
        isImageAlttext: false,  // 当前开关状态
        isImageFilename: false,   // 当前开关状态

        tagActive: [], //  是否高亮tag输入框
        ProductAltFixTagPop: false,
        ColAltFixTagPop: false,
        BlogAltFixTagPop: false,
        ProductFileFixTagPop: false,
        ColFileFixTagPop: false,
        BlogFileFixTagPop: false,

        isShowManuallyBtnLoading: false,  // 手动按钮loading
        manuallyTableState: {},
        historyTableState: {},

        progressCp: 0,      // 当前完成优化数量
        progressAll: 0,     // 需要完成总量
        isShowProgress: -1,   // 是否展示进度条
        allOptType: true,       // 是否存在任意一个
        optType: '',          // 优化类型
        optPageType: 0,
        stopLoading: false,

        batchLoading: true,     // 批量操作loading
        historyyPre: false,     // 历史记录分页
        historyNext: false,
        manuallyPre: false,     // 手动分页
        manuallyNext: false,
        initStateBtn: true, // 手动按钮初始化状态
        addTagsProAlt: '',
        addTagsColAlt: '',
        addTagsBlogAlt: '',
        addTagsProFile: '',
        addTagsColFile: '',
        addTagsBlogFile: '',
        isInLoading: false,
        isLocalStorage: false,    // 是否无痕
        errorImage: '',
        isShowEditTip: [],
        isShowWatermarkTip: true,

        isShowCompressionLevel: false,
        imageCompressionLevel: 2, // 推荐值
        imageCompressionLevelArr: {
            custom: 0,
            lossless: 0,
            custom_ratio: 0
        },
        isShowImgWatermark: false,

        isShowImgCompressionCol: true, // 伸缩状态
        isShowImgWatermarkCol: false,
        isShowImgAltTextCol: false,
        isShowImgFilenameCol: false,
        watermarkUrl: '/ImageOpt/watermark.png',  // 水印预览图片
        isShowSaveTip: false,
        ConvertImgJPG: false,
        isGuideTip: false,
        isShowSaveBar: false,   // 保存bar状态
        isDiscard: false,       // 是否操作了舍弃
        isShowLeastOneTip: false,   // 至少一个提示
        alt_num: 0,
        un_alt_num: 0,
        altPerc: 0,
        unAltPerc: 0,
        switchAltLoading: true,
    };

    UNSAFE_componentWillMount() {
        try {
            sessionStorage.setItem('localState', 1)
            this.setState({
                isLocalStorage: true,
            })
        } catch { }
    }

    componentDidMount() {
        // 切换默认在顶部开始预览
        window.scrollTo(0, 0);
        this.getAltData();
        this.getProductStatistics();
    }

    // 获取公共数据
    getAltData = async () => {
        const res = await reqGetAltData();
        if (res.ack === 1) {
            let _t = res.data;
            this.setState({
                alt_num: _t.now.alt_num,
                un_alt_num: _t.now.un_alt_num,
                altPerc: _t.past.alt_num === 0 ? (_t.now.alt_num === 0 ? 0 : 99) : Number((((_t.now.alt_num - _t.past.alt_num) / _t.past.alt_num)) * 100).toFixed(1),
                unAltPerc: _t.past.un_alt_num === 0 ? (_t.now.un_alt_num === 0 ? 0 : 99) : Number((((_t.now.un_alt_num - _t.past.un_alt_num) / _t.past.un_alt_num)) * 100).toFixed(1),
            })
        } else { }
    }

    // 获取产品页面统计数据
    getProductStatistics = async () => {
        let res = await reqGetImgOptTotal();
        if (res.ack === 1) {
            let t = res.total;
            let set = res.settings;
            let first = res.settings.is_default;
            this.setState({
                originSetData: res,
                total_saved_size: this.changeBitInfo(t.total_saved_size),
                avg_saved_space: this.changeBitInfo(t.avg_saved_space),
                avg_saved_percent: Number(t.total_original_size) === 0 ? 0 : Number(((Number(t.total_saved_size) / Number(t.total_original_size)) * 100).toFixed(2)),
                total_original_size: Number(t.total_original_size),
                total_compress_size: Number(t.total_compress_size),
                optimize_status: 0,
                is_default: first, // 是否第一次设置
                // firstSetSheetActive: res.settings.is_default === 1 ? true : false, // 第一次设置默认弹出
                impressionsUse: res.opt_schedule.impressions_use,
                impressionsAll: res.opt_schedule.impressions_all,
                auto_switch: Boolean(res.settings.auto_switch), // 自动状态
                isShowAutoState: Boolean(res.settings.auto_switch), // 自动开关状态
                // 设置
                image_opt: set.image_opt,
                alt_text: set.alt_text,
                file_name: set.file_name,

                isShowImgCompression: Boolean(set.image_opt?.switch), // 开关状态
                isShowImgAltText: Boolean(set.alt_text?.switch), // 开关状态
                isShowImgFilename: Boolean(set.file_name?.switch), // 开关状态
                productImg: set.image_opt?.product,
                ColImg: Boolean(set.image_opt?.collection),
                BlogImg: Boolean(set.image_opt?.blogs),
                ConvertImg: Boolean(set.image_opt?.pngtojpg),
                AddWaterImg: Boolean(set.image_opt?.watermark?.switch),
                imageAddWatermarkPosition: set.image_opt?.watermark?.position,  // 水印参数
                imageAddWatermarkSize: Number(set.image_opt?.watermark?.image_height) * 100,
                imageAddWatermarkOpacity: set.image_opt?.watermark?.opacity,
                imageAddWatermarkImg: set.image_opt?.watermark?.logo,
                productAlt: set.alt_text?.product,
                ColAlt: Boolean(set.alt_text?.collection),
                BlogAlt: Boolean(set.alt_text?.blogs),
                blankImgAlt: Boolean(set.alt_text?.blank_replace),
                productFile: set.file_name?.product,
                ColFile: Boolean(set.file_name?.collection),
                BlogFile: Boolean(set.file_name?.blogs),
                proAltTag: this.setDefaultTagFormat('product', set.alt_text?.product_rule),
                colAltTag: this.setDefaultTagFormat('collection', set.alt_text?.collection_rule),
                blogAltTag: this.setDefaultTagFormat('blog', set.alt_text?.blogs_rule),
                proFileTag: this.setDefaultTagFormat('product', set.file_name?.product_rule),
                colFileTag: this.setDefaultTagFormat('collection', set.file_name?.collection_rule),
                blogFileTag: this.setDefaultTagFormat('blog', set.file_name?.blogs_rule),
                addTagsProAlt: this.setDefaultTagFormat('product', set.alt_text?.product_rule),
                addTagsColAlt: this.setDefaultTagFormat('collection', set.alt_text?.collection_rule),
                addTagsBlogAlt: this.setDefaultTagFormat('blog', set.alt_text?.blogs_rule),
                // watermarkUrl: '/ImageOpt/watermark.png',  // 水印预览图片
                ConvertImgJPG: Boolean(set.image_opt?.pngtojpg_size_control),
                imageCompressionLevel: Boolean(set.image_opt?.quality) ? set.image_opt?.quality.custom === 0 ? 2 : (set.image_opt?.quality.custom_ratio === 90 ? 1 : set.image_opt?.quality.custom_ratio === 75 ? 2 : 3) : 2, // 推荐值
                imageCompressionLevelArr: Boolean(set.image_opt?.quality) ? set.image_opt.quality : { custom: 0, lossless: 0, custom_ratio: 0 },
                // isShowManuallyBtnLoading: res.opt_schedule.opt_total > 0 && res.opt_schedule.process_result !== 1 ? true : false,

                setSaveDisabled: first === 1 ? false : true,

                level: store.getState().public?.level,
                loadingPage: false,
                isShowSheetLoading: false,
                isShowSaveBar: false,
                switchAltLoading: false,
            }, () => {
                // this.props.setImageAutoSwitch(Boolean(res.settings.auto_switch))
                // this.handleDropImage(0, '', set.image_opt?.watermark?.logo);
                this.setState({
                    isDiscard: false,
                })
            })
        } else {
            this.props.toggleToast(res.message, true);
        }
    }

    // 设置tag
    setDefaultTag = () => {
        let { proAltTag, colAltTag, blogAltTag, proFileTag, colFileTag, blogFileTag, productAltList, colAltTagList, blogAltTagList, productFileList, colFileTagList, blogFileTagList } = this.state;
        let allTagList = {
            proAltTag: Boolean(proAltTag) ? proAltTag : `[[{"value":"${productAltList[0]['content']}"}]] - [[{"value":"${productAltList[4]['content']}"}]]`, // product
            colAltTag: Boolean(colAltTag) ? colAltTag : `[[{"value":"${colAltTagList[0]['content']}"}]] - [[{"value":"${colAltTagList[1]['content']}"}]]`, // collection
            blogAltTag: Boolean(blogAltTag) ? blogAltTag : `[[{"value":"${blogAltTagList[0]['content']}"}]] - [[{"value":"${blogAltTagList[1]['content']}"}]]`, // blog
            proFileTag: Boolean(proFileTag) ? proFileTag : `[[{"value":"${productFileList[0]['content']}"}]] - [[{"value":"${productFileList[4]['content']}"}]]`, // product
            colFileTag: Boolean(colFileTag) ? colFileTag : `[[{"value":"${colFileTagList[0]['content']}"}]] - [[{"value":"${colFileTagList[1]['content']}"}]]`, // collection
            blogFileTag: Boolean(blogFileTag) ? blogFileTag : `[[{"value":"${blogFileTagList[0]['content']}"}]] - [[{"value":"${blogFileTagList[1]['content']}"}]]`, // blog
        }
        this.setState({
            proAltTag: allTagList['proAltTag'],
            colAltTag: allTagList['colAltTag'],
            blogAltTag: allTagList['blogAltTag'],
            proFileTag: allTagList['proFileTag'],
            colFileTag: allTagList['colFileTag'],
            blogFileTag: allTagList['blogFileTag'],
            allTagList,
        })
    }

    // 转成tag输入框的数据格式
    setDefaultTagFormat = (type, data) => {
        let val = "";
        if (Boolean(data) && data !== '') {
            val = cloneDeep(data);
            val = val.replace(/\n/g, '');
            if (type === 'product') {
                val = val.replace(/%product_title%/g, '[[{"value":"Product title"}]]')
                    .replace(/%product_vendor%/g, '[[{"value":"Product vendor"}]]')
                    .replace(/%product_type%/g, '[[{"value":"Product type"}]]')
                    .replace(/%shop_name%/g, '[[{"value":"Shop name"}]]')
                    .replace(/%price%/g, '[[{"value":"Price"}]]')
                    .replace(/%product_variant%/g, '[[{"value":"Product variant"}]]');
            } else if (type === 'collection') {
                val = val.replace(/%collection_title%/g, '[[{"value":"Collection title"}]]')
                    .replace(/%shop_name%/g, '[[{"value":"Shop name"}]]');
            } else if (type === 'blog') {
                val = val.replace(/%blog_title%/g, '[[{"value":"Blog title"}]]')
                    .replace(/%shop_name%/g, '[[{"value":"Shop name"}]]');
            } else { }
        }

        return val;
    }

    // 比特转换
    changeBitInfo = (limit) => {
        let size = "";
        if (limit < 1 * 1024 * 1024) {
            //小于0.1MB，则转化成KB 
            size = (limit / 1024).toFixed(2) + "KB"
        } else if (limit < 1 * 1024 * 1024 * 1024) {
            //小于0.1GB，则转化成MB 
            size = (limit / (1024 * 1024)).toFixed(2) + "MB"
        } else {
            //其他转化成GB 
            size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB"
        }
        return size;
    }

    // 选择对应字段
    addApplyField = (type, name) => {
        let { proAltTag, colAltTag, blogAltTag, proFileTag, colFileTag, blogFileTag, isDiscard } = this.state;
        // 删除对应提示
        let curActive = cloneDeep(this.state.tagActive);
        if (curActive.includes(name)) {
            curActive.splice(curActive.indexOf(name), 1);
        }
        // 对象赋值
        let setObj =
            name === 'ProductAltFixTag' ? {
                proAltTag: !Boolean(proAltTag?.length) ? `[[{"value":"${type}"}]]` : `${proAltTag} [[{"value":"${type}"}]]`,
                addTagsProAlt: !Boolean(proAltTag?.length) ? `[[{"value":"${type}"}]]` : `${proAltTag} [[{"value":"${type}"}]]`
            } :
                name === 'ColAltFixTag' ? {
                    colAltTag: !Boolean(colAltTag?.length) ? `[[{"value":"${type}"}]]` : `${colAltTag} [[{"value":"${type}"}]]`,
                    addTagsColAlt: !Boolean(colAltTag?.length) ? `[[{"value":"${type}"}]]` : `${colAltTag} [[{"value":"${type}"}]]`,
                } :
                    name === 'BlogAltFixTag' ? {
                        blogAltTag: !Boolean(blogAltTag?.length) ? `[[{"value":"${type}"}]]` : `${blogAltTag} [[{"value":"${type}"}]]`,
                        addTagsBlogAlt: !Boolean(blogAltTag?.length) ? `[[{"value":"${type}"}]]` : `${blogAltTag} [[{"value":"${type}"}]]`,
                    } :
                        name === 'ProductFileFixTag' ? {
                            proFileTag: !Boolean(proFileTag?.length) ? `[[{"value":"${type}"}]]` : `${proFileTag} [[{"value":"${type}"}]]`,
                            addTagsProFile: !Boolean(proFileTag?.length) ? `[[{"value":"${type}"}]]` : `${proFileTag} [[{"value":"${type}"}]]`,
                        } :
                            name === 'ColFileFixTag' ? {
                                colFileTag: !Boolean(colFileTag?.length) ? `[[{"value":"${type}"}]]` : `${colFileTag} [[{"value":"${type}"}]]`,
                                addTagsColFile: !Boolean(colFileTag?.length) ? `[[{"value":"${type}"}]]` : `${colFileTag} [[{"value":"${type}"}]]`,
                            } :
                                name === 'BlogFileFixTag' ? {
                                    blogFileTag: !Boolean(blogFileTag?.length) ? `[[{"value":"${type}"}]]` : `${blogFileTag} [[{"value":"${type}"}]]`,
                                    addTagsBlogFile: !Boolean(blogFileTag?.length) ? `[[{"value":"${type}"}]]` : `${blogFileTag} [[{"value":"${type}"}]]`,
                                } : {};

        setObj[`${name}Pop`] = !Boolean(this.state[`${name}Pop`]);
        setObj['tagActive'] = curActive;
        setObj['setSaveDisabled'] = false;
        this.setState(setObj, () => {
            if (!isDiscard) {
                this.verifySavebarState();
            }
        });
    }

    // 获取tag输入框对象
    setTagifyData = (data, name) => {
        this.setState({
            [name]: data[0],
        })
        this.$name = data[1];
    }

    // 输入
    tagInputData = debounce((e, name) => {
        let { isDiscard, tagActive } = this.state;
        let curActive = cloneDeep(tagActive);
        const tagCompare = {
            proAltTag: "ProductAltFixTag",
            colAltTag: "ColAltFixTag",
            blogAltTag: "BlogAltFixTag",
            proFileTag: "ProductFileFixTag",
            colFileTag: "ColFileFixTag",
            blogFileTag: "BlogFileFixTag",
        }
        if (curActive.includes(tagCompare[name])) {
            curActive.splice(curActive.indexOf(tagCompare[name]), 1);
        }
        let value = "";
        if (e.type === "input") {
            value = e.detail.textContent;
            if (e.detail.tagify.value.length > 0) {
                e.detail.tagify.value.forEach(item => {
                    value = value.replace(new RegExp(`([^"])${item.value}([^"])`, 'g'), `$1[[{"value":"${item.value}"}]]$2`)
                })
            }
        } else {
            value = e.detail?.value;
            if (e.type === "remove") {
                value = e.detail.tagify.state.lastOriginalValueReported;
            }
        }
        this.setState({
            [name]: Boolean(value) ? value.replace(/[\n\u200B]/g, "") : '',
            tagActive: curActive,
            setSaveDisabled: false,
        }, () => {
            if (!isDiscard) {
                this.verifySavebarState();
            }
        })
    }, 100)

    // 无痕模式 - 输入
    tagInputDataTraceless = (val, name) => {
        let curActive = cloneDeep(this.state.tagActive);
        const tagCompare = {
            proAltTag: "ProductAltFixTag",
            colAltTag: "ColAltFixTag",
            blogAltTag: "BlogAltFixTag",
            proFileTag: "ProductFileFixTag",
            colFileTag: "ColFileFixTag",
            blogFileTag: "BlogFileFixTag",
        }
        if (curActive.includes(tagCompare[name])) {
            curActive.splice(curActive.indexOf(tagCompare[name]), 1);
        }
        let tagType = ['proAltTag', 'proFileTag'].includes(name) ? 'product' : ['colAltTag', 'colFileTag'].includes(name) ? 'collection' : 'blog';
        let tagVal = this.setDefaultTagFormat(tagType, val);
        this.setState({
            [name]: Boolean(tagVal) ? tagVal.replace(/[\n\u200B]/g, "") : '',
            tagActive: curActive,
            setSaveDisabled: false,
        })
    }

    // 设置 check
    changeCheckState = (val, name) => {
        this.setState({
            setSaveDisabled: false,
        }, () => {
            if (name.indexOf('product') > -1) {
                let names = name.split('-')[0];
                this.setState({
                    [names]: !Boolean(val) ? 0 : (name.indexOf('One') > -1 && Boolean(val)) ? 1 : 2,
                }, () => {
                    this.verifySavebarState();
                })
            } else {
                this.setState({
                    [name]: Boolean(val)
                }, () => {
                    this.verifySavebarState();
                })
            }
        })
    }

    // 改变tag下拉框状态
    changeSelectPop = (id) => {
        let name = `${id}Pop`;
        const tagState = {
            ProductAltFixTagPop: false,
            ColAltFixTagPop: false,
            BlogAltFixTagPop: false,
            ProductFileFixTagPop: false,
            ColFileFixTagPop: false,
            BlogFileFixTagPop: false,
        }
        tagState[name] = !Boolean(this.state[name]);
        this.setState(tagState);
    }

    // 状态切换 正负
    handleStateChange = (name, val) => {
        let { productAlt, ColAlt, BlogAlt, } = this.state;
        if (!Boolean(productAlt) && !Boolean(ColAlt) && !Boolean(BlogAlt)) {
            this.setState({
                isShowLeastOneTip: true,
            })
        } else {
            this.setState({
                [name]: val,
                switchAltLoading: true,
            }, () => {
                this.saveImageAltData();
            })
        }
    }

    // 格式化tag数据
    changeTagFormat = (type, data) => {
        let val = cloneDeep(data);
        val = val.replace(/\n/g, '');
        if (type === 'product') {
            val = val.replace(/\[\[{"value":"Product title"}\]\]/g, '%product_title%')
                .replace(/\[\[{"value":"Product vendor"}\]\]/g, '%product_vendor%')
                .replace(/\[\[{"value":"Product type"}\]\]/g, '%product_type%')
                .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shop_name%')
                .replace(/\[\[{"value":"Price"}\]\]/g, '%price%')
                .replace(/\[\[{"value":"Product variant"}\]\]/g, '%product_variant%');
        } else if (type === 'collection') {
            val = val.replace(/\[\[{"value":"Collection title"}\]\]/g, '%collection_title%')
                .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shop_name%');
        } else if (type === 'blog') {
            val = val.replace(/\[\[{"value":"Blog title"}\]\]/g, '%blog_title%')
                .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shop_name%');
        } else { }

        return val;
    }

    // 保存设置
    saveImageAltData = (type) => {
        let {
            auto_switch,
            is_default,
            // image_opt,
            isShowImgCompression,
            isShowImgAltText,
            isShowImgFilename,
            productImg,
            ColImg,
            BlogImg,
            ConvertImg,
            AddWaterImg,
            imageAddWatermarkPosition,
            imageAddWatermarkSize,
            imageAddWatermarkOpacity,
            productAlt,
            ColAlt,
            BlogAlt,
            blankImgAlt,
            productFile,
            ColFile,
            BlogFile,
            proAltTag,
            colAltTag,
            blogAltTag,
            proFileTag,
            colFileTag,
            blogFileTag,
            imageAddWatermarkImg,
            imageData,
            imageCompressionLevelArr,
            ConvertImgJPG,

        } = this.state;
        if (!Boolean(productAlt) && !Boolean(ColAlt) && !Boolean(BlogAlt)) {
            this.setState({
                isShowLeastOneTip: true,
            })
        } else {
            // 判断是否自动开关还是设置保存
            let params = {};
            if (type === 'switch') {
                params = {
                    auto_switch: Number(auto_switch),
                }
            } else {
                let tagActive = [];
                if (isShowImgAltText) {
                    if (productAlt && !Boolean(proAltTag.replace(/[\s\n\u200B]/g, ""))) {
                        tagActive.push('ProductAltFixTag');
                    }
                    if (ColAlt && !Boolean(colAltTag.replace(/[\s\n\u200B]/g, ""))) {
                        tagActive.push('ColAltFixTag');
                    }
                    if (BlogAlt && !Boolean(blogAltTag.replace(/[\s\n\u200B]/g, ""))) {
                        tagActive.push('BlogAltFixTag');
                    }
                }
                if (isShowImgFilename) {
                    if (productFile && !Boolean(proFileTag.replace(/[\s\n\u200B]/g, ""))) {
                        tagActive.push('ProductFileFixTag');
                    }
                    if (ColFile && !Boolean(colFileTag.replace(/[\s\n\u200B]/g, ""))) {
                        tagActive.push('ColFileFixTag');
                    }
                    if (BlogFile && !Boolean(blogFileTag.replace(/[\s\n\u200B]/g, ""))) {
                        tagActive.push('BlogFileFixTag');
                    }
                }
                this.setState({
                    tagActive,
                })
                if (tagActive.length > 0) {
                    // this.props.toggleToast('The input value cannot be empty', false);
                    return false;
                }

                params = {
                    alt_text: {
                        blogs: Number(BlogAlt),
                        switch: Number(isShowImgAltText),
                        product: Number(Boolean(productAlt) ? productAlt : 0),
                        blogs_rule: this.changeTagFormat('blog', blogAltTag),
                        collection: Number(ColAlt),
                        product_rule: this.changeTagFormat('product', proAltTag),
                        blank_replace: Number(blankImgAlt),
                        collection_rule: this.changeTagFormat('collection', colAltTag),
                    },
                    file_name: {
                        blogs: Number(BlogFile),
                        switch: Number(isShowImgFilename),
                        product: Number(Boolean(productFile) ? productFile : 0),
                        blogs_rule: this.changeTagFormat('blog', blogFileTag),
                        collection: Number(ColFile),
                        product_rule: this.changeTagFormat('product', proFileTag),
                        collection_rule: this.changeTagFormat('collection', colFileTag)
                    },
                    is_default: is_default,
                    auto_switch: Number(store.getState().public.imageOptAuto),
                    image_opt: {
                        switch: Number(isShowImgCompression),
                        product: Number(Boolean(productImg) ? productImg : 0),
                        collection: Number(ColImg),
                        blogs: Number(BlogImg),
                        pngtojpg: Number(ConvertImg),
                        pngtojpg_size_control: Number(ConvertImgJPG),
                        quality: imageCompressionLevelArr,
                        watermark: {
                            switch: Number(AddWaterImg),
                            logo: imageAddWatermarkImg,
                            // file_data: imageAddWatermarkImg,
                            // file_name: Boolean(imageData) && imageData.length > 0 ? imageData[0].name : '',
                            position: imageAddWatermarkPosition,
                            image_height: Number(Number(imageAddWatermarkSize / 100).toFixed(2)),
                            opacity: Number(imageAddWatermarkOpacity)
                        }
                    }
                }
                if (imageAddWatermarkImg.indexOf('base64') > -1) {
                    params['image_opt']['watermark']['file_data'] = imageAddWatermarkImg;
                    params['image_opt']['watermark']['file_name'] = Boolean(imageData) && imageData.length > 0 ? imageData[0].name : '';
                    params['image_opt']['watermark']['logo'] = "";
                }
            }
            this.setState({
                setSaveLoading: true,
            }, async () => {
                const res = await reqSaveSettings(params);
                if (res.ack === 1) {
                    window.savebarState = false;
                    this.props.toggleToast(res.msg, false);
                    this.setState({
                        setSaveDisabled: true,
                        setSaveLoading: false,
                        switchAltLoading: false,
                        isShowLeastOneTip: false,
                        isShowSaveBar: false,
                        saveLoading: false
                    }, () => {
                        this.getProductStatistics();
                        this.$historyAct.getProductStatistics();
                        // 更新新手引导状态
                        let data = cloneDeep(store.getState().public.publicInit.head_data?.switch_data || []);
                        if (data?.get_guide_coupon && data?.get_guide_coupon?.st !== 1) {
                            data.manual_guide.img_comp = { "at": Math.floor(new Date().getTime() / 1000), "st": 1 };
                            store.dispatch(setSaveSwitchData(data));
                        }
                    })
                } else {
                    this.props.toggleToast(res.msg, true);
                    this.setState({
                        setSaveDisabled: false,
                        setSaveLoading: false,
                    })
                }
            })
        }
    }

    // 舍弃
    handleShopifyDiscard = () => {
        window.savebarState = false;
        this.setState({
            isShowSaveBar: false,
            loadingPage: true,
            isDiscard: true,
            isShowLeastOneTip: false,
        }, () => {
            setTimeout(() => {
                this.getProductStatistics();
            }, 500)
        })
    }

    //点击联系客服
    handleContactService = () => {
        try {
            window.Willdesk.show()
        } catch (e) {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    // 关闭没有填写提示
    closeNotEditTip = (i) => {
        let curIndex = cloneDeep(this.state.isShowEditTip);
        curIndex.push(i);
        this.setState({
            isShowEditTip: curIndex
        })
    }

    // 保存bar
    changeSaveBarState = (_state) => {
        window.savebarState = _state;
        this.setState({
            isShowSaveBar: _state,
        })
    }

    // 检测保存bar 状态
    verifySavebarState = () => {
        let { originSetData, productAlt, proAltTag, ColAlt, colAltTag, BlogAlt, blogAltTag, blankImgAlt, setSaveLoading } = this.state;
        let _o = originSetData.settings.alt_text;
        let proTag = this.changeTagFormat('product', proAltTag);
        let colTag = this.changeTagFormat('collection', colAltTag);
        let blogTag = this.changeTagFormat('blog', blogAltTag);
        if (!setSaveLoading) {
            if (_o.product !== productAlt || Boolean(_o.collection) !== Boolean(ColAlt) || Boolean(_o.blogs) !== Boolean(BlogAlt) || _o.product_rule !== proTag || _o.collection_rule !== colTag || _o.blogs_rule !== blogTag || Boolean(_o.blank_replace) !== Boolean(blankImgAlt)) {
                this.changeSaveBarState(true);
            } else {
                this.changeSaveBarState(false);
            }
        }
    }

    // 设置事件
    setHistoryAction = (action) => {
        this.$historyAct = action;
    }

    render() {
        const {
            state: {
                loadingPage,
                questionList,
                isShowImgAltText,
                productAlt,
                ColAlt,
                BlogAlt,
                blankImgAlt,
                tagActive,
                proAltTag,
                colAltTag,
                blogAltTag,
                productAltList,
                colAltTagList,
                blogAltTagList,
                ProductAltFixTagPop,
                ColAltFixTagPop,
                BlogAltFixTagPop,
                isLocalStorage,
                addTagsProAlt,
                addTagsColAlt,
                addTagsBlogAlt,
                isShowSaveBar,
                setSaveLoading,
                isShowLeastOneTip,
                alt_num,
                un_alt_num,
                altPerc,
                unAltPerc,
                switchAltLoading,
            },

        } = this;

        // 首次设置抽屉
        const warnIcon = <svg t="1695125243916" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11078" width="20" height="20"><path d="M959.256366 512C959.256366 264.98713 759.01287 64.743634 512 64.743634 264.98713 64.743634 64.743634 264.98713 64.743634 512 64.743634 759.01287 264.98713 959.256366 512 959.256366 759.01287 959.256366 959.256366 759.01287 959.256366 512L959.256366 512 959.256366 512 959.256366 512 959.256366 512 959.256366 512ZM117.36203 512C117.36203 294.047467 294.047467 117.36203 512 117.36203 729.952533 117.36203 906.63797 294.047467 906.63797 512 906.63797 729.952533 729.952533 906.63797 512 906.63797 294.047467 906.63797 117.36203 729.952533 117.36203 512L117.36203 512 117.36203 512 117.36203 512 117.36203 512 117.36203 512Z" fill="#FC5143" p-id="11079"></path><path d="M484.457558 599.560299C484.457558 622.580963 495.008537 634.091122 516.110812 634.091122 537.213087 634.091122 547.764066 622.580963 547.764066 599.560299L547.764066 280.150193C547.764066 257.129529 537.213087 245.61937 516.110812 245.61937 495.008537 245.61937 484.457558 257.129529 484.457558 280.150193L484.457558 599.560299ZM478.702421 740.561158C480.62081 763.581821 493.090149 775.091981 516.110812 775.091981 539.131476 775.091981 551.600815 763.581821 553.519203 740.561158 551.600815 717.540494 539.131476 705.071155 516.110812 703.152767 493.090149 705.071155 480.62081 717.540494 478.702421 740.561158L478.702421 740.561158Z" fill="#FC5143" p-id="11080"></path></svg>
        const TipBannerSet = (index) => {
            return <div className='tip_banner_setting'>
                <Banner
                    title={t("Optimization cannot occur until you have set up at least one item.")}
                    tone='warning'
                    action={{
                        content: t("Contact us"),
                        onAction: this.handleContactService
                    }}
                    onDismiss={() => {
                        this.setState({ isShowLeastOneTip: false })
                    }}
                >
                </Banner>
            </div>
        }

        // 格式化数据
        const TracelessTagsData = (type, val) => {
            let formatVal = val.replace(/\n/g, '');
            if (['ProductAltFixTag', 'ProductFileFixTag'].includes(type)) {
                formatVal = formatVal.replace(/\[\[{"value":"Product title"}\]\]/g, '%product_title%')
                    .replace(/\[\[{"value":"Product vendor"}\]\]/g, '%product_vendor%')
                    .replace(/\[\[{"value":"Product type"}\]\]/g, '%product_type%')
                    .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shop_name%')
                    .replace(/\[\[{"value":"Price"}\]\]/g, '%price%')
                    .replace(/\[\[{"value":"Product variant"}\]\]/g, '%product_variant%');
            } else if (['ColAltFixTag', 'ColFileFixTag'].includes(type)) {
                formatVal = formatVal.replace(/\[\[{"value":"Collection title"}\]\]/g, '%collection_title%')
                    .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shop_name%');
            } else if (['BlogAltFixTag', 'BlogFileFixTag'].includes(type)) {
                formatVal = formatVal.replace(/\[\[{"value":"Blog title"}\]\]/g, '%blog_title%')
                    .replace(/\[\[{"value":"Shop name"}\]\]/g, '%shop_name%');
            } else { }

            return formatVal;
        }

        // 顶部数据模块
        const upIcon = <svg width="8" height="8" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.583829 6.41608C0.398001 6.23025 0.398001 5.92896 0.583829 5.74313L4.93088 1.39608L2.49053 1.3962C2.22773 1.39622 2.01468 1.18318 2.01466 0.920384C2.01465 0.657582 2.22768 0.444529 2.49048 0.444516L6.0797 0.444336C6.20591 0.44433 6.32695 0.494463 6.4162 0.583707C6.50544 0.672951 6.55558 0.793994 6.55557 0.920204L6.55539 4.50942C6.55538 4.77222 6.34232 4.98526 6.07952 4.98524C5.81672 4.98523 5.60369 4.77218 5.6037 4.50937L5.60382 2.06903L1.25677 6.41608C1.07095 6.6019 0.769658 6.6019 0.583829 6.41608Z" fill="#29CC6A" />
        </svg>
        const downIcon = <svg width="8" height="8" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M1.0838 0.583707C1.26963 0.397879 1.57092 0.397879 1.75675 0.583707L6.1038 4.93076L6.10367 2.49041C6.10366 2.22761 6.31669 2.01455 6.57949 2.01454C6.8423 2.01453 7.05535 2.22756 7.05536 2.49036L7.05554 6.07958C7.05555 6.20579 7.00541 6.32683 6.91617 6.41608C6.82693 6.50532 6.70588 6.55545 6.57967 6.55545L2.99046 6.55527C2.72765 6.55525 2.51462 6.3422 2.51464 6.0794C2.51465 5.8166 2.7277 5.60357 2.9905 5.60358L5.43085 5.6037L1.0838 1.25665C0.897974 1.07082 0.897974 0.769536 1.0838 0.583707Z" fill="#B5B5B5" />
        </svg>
        const TopDataBlock = <div className='TopDataAlt'>
            <Card padding={300}>
                <BlockStack gap={100}>
                    {/* <Tooltip content={t("Alt text added")}> */}
                    <p className='Every_Card_Text'>{t("Alt text added")}</p>
                    {/* </Tooltip> */}
                    <div className='flex_layout'>
                        <div className='top_data top_data_box'>{alt_num}</div>
                        {(altPerc !== 0) ? <span className={altPerc > 0 ? "up_alt" : "down_alt"}>
                            {altPerc > 0 ? upIcon : downIcon}&nbsp;
                            {
                                altPerc === 99 ? <span>+{alt_num}</span> : <span>{`${altPerc}%`}</span>
                            }
                        </span> : null}
                    </div>
                </BlockStack>
            </Card>
            <Card padding={300}>
                <BlockStack gap={100}>
                    {/* <Tooltip content={t("Images without alt text")}> */}
                    <p className='Every_Card_Text'>{t("Images without alt text")}</p>
                    {/* </Tooltip> */}
                    <div className='flex_layout'>
                        <div className='top_data top_data_box'>{un_alt_num}</div>
                        {(unAltPerc !== 0) ? <span className={unAltPerc > 0 ? "up_alt" : "down_alt"}>
                            {unAltPerc > 0 ? upIcon : downIcon}&nbsp;
                            {
                                unAltPerc === 99 ? <span>+{un_alt_num}</span> : <span>{`${unAltPerc}%`}</span>
                            }
                        </span> : null}
                    </div>
                </BlockStack>
            </Card>
        </div>

        // 页面内容
        const ImageAltCard = <Card>
            <div className='ImageSetItems ImageAltText_Box'>
                <div>
                    <BlockStack>
                        <div className='flex_layout' style={{ justifyContent: 'space-between' }}>
                            <div className='flex_layout'>
                                <Text variant="headingMd" as="h2">{t("Auto add image alt text")}</Text>
                                <Badge tone={isShowImgAltText ? 'success' : ''}>{isShowImgAltText ? t("On") : t("Off")}</Badge>
                            </div>
                            <div className='flex_layout' onClick={(e) => { e.stopPropagation() }}>
                                {switchAltLoading && <img className="Loading" src="/loading.gif" style={{ width: '19.2px', margin: '0 6.4px' }} alt="loading" />}
                                <Switch disabled={switchAltLoading} onChange={() => this.handleStateChange('isShowImgAltText', !isShowImgAltText)} checked={isShowImgAltText} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
                            </div>
                        </div>
                        <Text as="p" color="subdued">{t("When enable, SEOAnt automatically generates image alt text based on predefined rules.")}</Text>
                    </BlockStack>
                </div>
                <div className='row_line_1'></div>
                {
                    Boolean(isShowLeastOneTip) ? TipBannerSet(2) : null
                }
                <div className='image_alt_setting'>
                    <div>
                        <Text variant="headingMd" as="h2">{t("Application range")}</Text>
                    </div>
                    <div className='imgSet_item'>
                        <Checkbox
                            label={t("All product image alt")}
                            id="productAlt-One"
                            checked={productAlt === 1}
                            onChange={this.changeCheckState}
                        />
                        <Checkbox
                            label={t("Only published product image alt")}
                            id="productAlt-Two"
                            checked={productAlt === 2}
                            onChange={this.changeCheckState}
                        />
                    </div>
                    <div className={`${Boolean(productAlt) ? 'imgSet_tag' : 'imgSet_tag_out'}`}>
                        <Collapsible
                            open={Boolean(productAlt)}
                            id={`productAlt-collapsible`}
                            transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                            expandOnPrint
                        >
                            {
                                Boolean(isLocalStorage) ? <>
                                    <FreeTagInputMix
                                        id={"ProductAltFixTag"}
                                        tagActive={tagActive}
                                        defaultTag={proAltTag}
                                        actionList={productAltList}
                                        isShowSelectPop={ProductAltFixTagPop}
                                        changeSelectPop={this.changeSelectPop}
                                        tagInputData={(e) => this.tagInputData(e, 'proAltTag')}
                                        addTags={addTagsProAlt}
                                    />
                                    {
                                        (tagActive.length > 0 && tagActive.includes("ProductAltFixTag")) ? <div className='flex_layout warnTip'>
                                            {warnIcon}
                                            <span>{t("The input cannot be empty!")}</span>
                                        </div> : null
                                    }
                                </> :
                                    <FreeTagInputTraceless
                                        id={"ProductAltFixTag"}
                                        tagActive={tagActive}
                                        defaultTag={TracelessTagsData('ProductAltFixTag', proAltTag)}
                                        actionList={productAltList}
                                        isShowSelectPop={ProductAltFixTagPop}
                                        changeSelectPop={this.changeSelectPop}
                                        tagInputDataTraceless={(val) => this.tagInputDataTraceless(val, 'proAltTag')}
                                    />
                            }
                        </Collapsible>
                    </div>
                    <div className='imgSet_item'>
                        <Checkbox
                            label={t("Collection image alt")}
                            id="ColAlt"
                            checked={ColAlt}
                            onChange={this.changeCheckState}
                        />
                        <div className={`${ColAlt ? 'imgSet_tag' : 'imgSet_tag_out'}`}>
                            <Collapsible
                                open={ColAlt}
                                id={`ColAlt-collapsible`}
                                transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                                expandOnPrint
                            >
                                {
                                    Boolean(isLocalStorage) ? <>
                                        <FreeTagInputMix
                                            id={"ColAltFixTag"}
                                            tagActive={tagActive}
                                            defaultTag={colAltTag}
                                            actionList={colAltTagList}
                                            isShowSelectPop={ColAltFixTagPop}
                                            changeSelectPop={this.changeSelectPop}
                                            tagInputData={(e) => this.tagInputData(e, 'colAltTag')}
                                            addTags={addTagsColAlt}
                                        />
                                        {
                                            (tagActive.length > 0 && tagActive.includes("ColAltFixTag")) ? <div className='flex_layout warnTip'>
                                                {warnIcon}
                                                <span>{t("The input cannot be empty!")}</span>
                                            </div> : null
                                        }
                                    </> :
                                        <FreeTagInputTraceless
                                            id={"ColAltFixTag"}
                                            tagActive={tagActive}
                                            defaultTag={TracelessTagsData('ColAltFixTag', colAltTag)}
                                            actionList={colAltTagList}
                                            isShowSelectPop={ColAltFixTagPop}
                                            changeSelectPop={this.changeSelectPop}
                                            tagInputDataTraceless={(val) => this.tagInputDataTraceless(val, 'colAltTag')}
                                        />
                                }
                            </Collapsible>
                        </div>
                    </div>
                    <div className='imgSet_item'>
                        <Checkbox
                            label={t("Blog post image alt")}
                            id="BlogAlt"
                            checked={BlogAlt}
                            onChange={this.changeCheckState}
                        />
                        <div className={`${BlogAlt ? 'imgSet_tag' : 'imgSet_tag_out'}`}>
                            <Collapsible
                                open={BlogAlt}
                                id={`BlogAlt-collapsible`}
                                transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                                expandOnPrint
                            >
                                {
                                    Boolean(isLocalStorage) ? <>
                                        <FreeTagInputMix
                                            id={"BlogAltFixTag"}
                                            tagActive={tagActive}
                                            defaultTag={blogAltTag}
                                            actionList={blogAltTagList}
                                            isShowSelectPop={BlogAltFixTagPop}
                                            changeSelectPop={this.changeSelectPop}
                                            tagInputData={(e) => this.tagInputData(e, 'blogAltTag')}
                                            addTags={addTagsBlogAlt}
                                        />
                                        {
                                            (tagActive.length > 0 && tagActive.includes("BlogAltFixTag")) ? <div className='flex_layout warnTip'>
                                                {warnIcon}
                                                <span>{t("The input cannot be empty!")}</span>
                                            </div> : null
                                        }
                                    </> :
                                        <FreeTagInputTraceless
                                            id={"BlogAltFixTag"}
                                            tagActive={tagActive}
                                            defaultTag={TracelessTagsData('BlogAltFixTag', blogAltTag)}
                                            actionList={blogAltTagList}
                                            isShowSelectPop={BlogAltFixTagPop}
                                            changeSelectPop={this.changeSelectPop}
                                            tagInputDataTraceless={(val) => this.tagInputDataTraceless(val, 'blogAltTag')}
                                        />
                                }
                            </Collapsible>
                        </div>
                    </div>
                    {(Boolean(productAlt) || Boolean(ColAlt) || Boolean(BlogAlt)) && <div className='row_line_1p5'></div>}
                    <div className='imgSet_item'>
                        {
                            (Boolean(productAlt) || Boolean(ColAlt) || Boolean(BlogAlt)) ?
                                <Checkbox
                                    label={t("Only for images without Alt text")}
                                    id="blankImgAlt"
                                    checked={blankImgAlt}
                                    onChange={this.changeCheckState}
                                    helpText={t("If checked, alt attributes will only be generated for images that are not optimized and do not have alt attributes. If unchecked, alt attributes will be generated for all unoptimized images.")}
                                /> : null
                        }
                    </div>
                </div>
            </div>
        </Card>


        // 历史记录
        const HistoryTableBox = <HistoryTable
            setHistoryAction={this.setHistoryAction}
            toggleToast={this.props.toggleToast}
        />

        // 常见问题
        const FrequentlyItems = <FaqCardBox FaqList={questionList} />

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 最终页面
        const pageContent = loadingPage ? <SkeltonLoading /> : <Page
        >
            <div className='Image_alt_text'>
                <title>SEOAnt - Image alt text</title>

                <BlockStack gap={400}>
                    {TopDataBlock}
                    {/* 内容 */}
                    {ImageAltCard}
                    {HistoryTableBox}
                    {/* FAQ */}
                    {FrequentlyItems}
                </BlockStack>
                {/* 底部 */}
                {FooterHelpBox}
            </div>
        </Page>;


        return <>
            <SaveBarTop
                isShowSaveBar={isShowSaveBar}
                saveLoading={setSaveLoading}
                handleSaveAction={this.saveImageAltData}
                handleDiscardAction={this.handleShopifyDiscard}
            />
            {pageContent}
        </>;
    }

}
const mapStateToProps = state => {
    return state
}
const mapDispatchToProps = dispatch => ({

    // 设置自定义缓存
    setSwitchData(data) {
        dispatch(setSaveSwitchData(data))
    },

    // 判断是否页面第一次loading
    getPageDataRedux(data) {
        dispatch(setPageData(['InstantIndex', data]));
    },


})

indexClass = connect(
    mapStateToProps,
    mapDispatchToProps
)(indexClass);

export default withRouter(indexClass);
